import api from './index';

const basePath = (entityId) => `/api/v1/entities/${entityId}/sheets`;

export default {
  create(entityId, newSheetUrl) {
    return api({
      method: 'post',
      data: newSheetUrl,
      url: `${basePath(entityId)}`,
    });
  },
  delete(entityId, sheetId) {
    return api({
      method: 'delete',
      url: `${basePath(entityId)}/${sheetId}`,
    });
  },
};
